export default __webpack_public_path__ + "9a51ae7c3853b708f352ef62f7680c6c.png";